import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { AuthorizationService } from '../../services/authorization.service';

@Injectable()
export class RoleGuard {
  readonly defaultRedirect = '/users/profile';

  constructor(
    private authService: AuthorizationService,
    private router: Router) {
  }

  // eslint-disable-next-line no-unused-vars
  canMatch(route: Route, _segments: UrlSegment[]): Observable<boolean> {
    return this.validate(route);
  }

  canActivate(routeSnapshot: ActivatedRouteSnapshot): Observable<boolean> {
    return this.validate(routeSnapshot.routeConfig);
  }

  protected validate(route: Route): Observable<boolean> {
    return this.authService.validateAccess(this.getRoles(route)).pipe(take(1),
      tap(isAuthorized => isAuthorized || this.router.navigate([this.getRedirect(route)])));
  }

  private getRoles(route) {
    return (route.data && route.data['roles']) || [];
  }

  private getRedirect(route) {
    return (route.data && route.data['guardRedirect']) || this.defaultRedirect;
  }
}
